import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9d19d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-member" }
const _hoisted_2 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal fd-member-carousel"
}
const _hoisted_3 = { class: "el-carousel__container" }
const _hoisted_4 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_5 = { class: "fd-member-ct" }
const _hoisted_6 = { class: "fd-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("会员权益")
const _hoisted_8 = { class: "fd-member-equity-ct" }
const _hoisted_9 = { class: "fd-member-equity-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-title" }, "地产物业会员", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-nums" }, "2万元/年", -1))
const _hoisted_12 = { class: "fd-member-equity-line" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 总部管理子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "5"),
    /*#__PURE__*/_createTextVNode("个 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 区域管理子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "35"),
    /*#__PURE__*/_createTextVNode("个 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 项目招商子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "160"),
    /*#__PURE__*/_createTextVNode("个 ")
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 新盘项目拎包招商信息发布/商家对接 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 次新盘项目拎包招商信息发布/商家对接 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 存量盘项目拎包招商信息发布/商家对接 ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在全国拎包商家库中精准检索优质商家 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在厂家库中检索有成熟拎包体系的品牌 ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在社区美居网发布拎包专业人才招聘信息 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在社区美居网专业人才库中搜索人才简历 ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 项目报名商家统计表 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 签约进驻商家统计表 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 物业对商家满意度统计表 ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 拎包年会名额"),
    /*#__PURE__*/_createElementVNode("span", null, "2"),
    /*#__PURE__*/_createTextVNode("个/年 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 拎包培训/论坛/参访名额不少于"),
    /*#__PURE__*/_createElementVNode("span", null, "6"),
    /*#__PURE__*/_createTextVNode("个/年 ")
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 社区渠道活跃品牌等信息 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, "社区创新营销模式等信息")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, "社区美居网报道"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 社区美居公众号报道 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" “社区美居俱乐部会员”精美牌匾"),
    /*#__PURE__*/_createElementVNode("span", null, "1"),
    /*#__PURE__*/_createTextVNode("个 ")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("加入会员 ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-des" }, [
  /*#__PURE__*/_createTextVNode(" 具体内容见"),
  /*#__PURE__*/_createElementVNode("span", null, "《地产物业会员协议》")
], -1))
const _hoisted_23 = { class: "fd-member-equity-ct" }
const _hoisted_24 = { class: "fd-member-equity-icon" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-title" }, "品牌厂家会员", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-nums" }, "2万元/年", -1))
const _hoisted_27 = { class: "fd-member-equity-line" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 总部管理子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "5"),
    /*#__PURE__*/_createTextVNode("个 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 大区管理子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "15"),
    /*#__PURE__*/_createTextVNode("个 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 片区管理子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "80"),
    /*#__PURE__*/_createTextVNode("个 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 经销商子账号"),
    /*#__PURE__*/_createElementVNode("span", null, "300"),
    /*#__PURE__*/_createTextVNode("个 ")
  ])
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 新盘项目拎包招商信息查询/项目报名对接 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 次新盘拎包招商信息查询/项目报名对接 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 存量盘拎包招商信息查询/项目报名对接 ")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 本品牌经销商项目报名统计表 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 本品牌经销商项目签约进驻统计表 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 本品牌经销商拎包在场经营中项目统计表 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 物业对本品牌经销商满意度统计表 ")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在社区美居网发布拎包专业人才招聘信息 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在社区美居网专业人才库中搜索人才简历 ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 拎包年会名额"),
    /*#__PURE__*/_createElementVNode("span", null, "2"),
    /*#__PURE__*/_createTextVNode("个/年 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 拎包培训\\论坛\\参访名额不少于"),
    /*#__PURE__*/_createElementVNode("span", null, "6"),
    /*#__PURE__*/_createTextVNode("个/年 ")
  ])
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 地产物业社区美居业务信息动态 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 社区渠道创新业务模式信息 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, "社区渠道创新营销模式信息")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, "社区美居网报道"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 社区美居公众号报道 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 社区美居网物业会员走访推荐 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" “社区美居俱乐部会员”精美牌匾"),
    /*#__PURE__*/_createElementVNode("span", null, "1"),
    /*#__PURE__*/_createTextVNode("个 ")
  ])
], -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("加入会员 ")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-des" }, [
  /*#__PURE__*/_createTextVNode(" 具体内容见"),
  /*#__PURE__*/_createElementVNode("span", null, "《地产物业会员协议》")
], -1))
const _hoisted_37 = { class: "fd-member-equity-ct" }
const _hoisted_38 = { class: "fd-member-equity-icon" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-title" }, "社区商家会员", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-nums" }, "399元/年", -1))
const _hoisted_41 = { class: "fd-member-equity-line" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" 社区美居网商家账号"),
    /*#__PURE__*/_createElementVNode("span", null, "1"),
    /*#__PURE__*/_createTextVNode("个 ")
  ])
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 可查询物业发布的(对应区域内)招商项目详细信息 ")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 感兴趣的目标项目可线上报名 ")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 与物业项目人员线下对接洽谈、签约进驻 ")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 商家将自己的资质信息及社区优秀案例上传系统后，有机会被物业检索到/邀约合作 ")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 会员商家参加拎包训练营可获得费用优惠 ")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 优秀商家会员有机会被邀约参加俱乐部的论坛/参访等活动 ")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在社区美居网发布拎包专业人才招聘信息 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 在社区美居网专业人才库中搜索人才简历 ")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, "社区美居网构建商家自己的广宣阵地"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, " 对口物业项目推荐(限优秀商家) "),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-form-label" }, [
    /*#__PURE__*/_createTextVNode(" “社区美居俱乐部会员”精美牌匾"),
    /*#__PURE__*/_createElementVNode("span", null, "1"),
    /*#__PURE__*/_createTextVNode("个 ")
  ])
], -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode("加入会员 ")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-equity-line-des" }, [
  /*#__PURE__*/_createTextVNode(" 具体内容见"),
  /*#__PURE__*/_createElementVNode("span", null, "《地产物业会员协议》")
], -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode("入会流程")
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-flow-label" }, "在线报名填资料", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-flow-label" }, "平台审核", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-flow-label" }, "在线付费", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-flow-label" }, "畅享会员权益", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-member-des" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-des-label" }, "社区拎包入住领域最全的资源和资讯都在这里"),
  /*#__PURE__*/_createElementVNode("div", { class: "fd-member-des-label" }, " 加入“社区美居俱乐部”会员，畅享海量资源，共赢消费社区化大时代 ")
], -1))

import store from "@/store/index";
import { ref, reactive } from "vue";
import { shallowReactive } from "vue";
import router from "@/router/index";
import {
  School,
  House,
  Shop,
  Right,
  Coin,
  CoffeeCup,
  Edit,
  WalletFilled,
} from "@element-plus/icons-vue";
import Bottom from "./components/bottom.vue";

interface tabNames {
  name: string;
  count: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const investDeveloperNames: tabNames[] = [];
const communityBrandNames: tabNames[] = [];
const bagJoinBrandNames: tabNames[] = [];
const bindData = reactive({
  investDeveloperNames: investDeveloperNames,
  communityBrandNames: communityBrandNames,
  bagJoinBrandNames: bagJoinBrandNames,
  isShowDefaultImage: true,
  defaultImage: "",
  images: [],
  calssType: ["", "", "", "status3", "status4", "status5", "status6"],
  type: ["", "", "", "即将开始", "报名中", "进行中", "已结束"],
});

const handleToRegister = (type: number) => {
  router.push('/frontDesk/register/' + type)
}

setTimeout(() => {
  bindData.isShowDefaultImage = false;
}, 3000);

const advertisingImageEvent = () => {
  store.dispatch("frontIndexModule/listAdvertisingImage", { type: 6 }).then(
    (data) => {
      console.log(data.result);
      bindData.images = data.result;
      if (data.result.length > 0) {
        bindData.defaultImage = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

advertisingImageEvent();

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                class: "fd-member-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "fd-member-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "fd-member-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_container, { class: "fd-member-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          gutter: 20,
          class: "fd-member-equity"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              class: "fd-member-equity-box",
              span: 8,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_image, {
                      class: "fd-member-equity-icon-img",
                      src: require('@/assets/fd/member/u765.png')
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_10,
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_form, {
                      class: "fd-member-equity-line-form",
                      "label-width": "70px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "软件帐号" }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "招商发布" }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "厂商检索" }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "专才招募" }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "管理统计" }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "行业交流" }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "行业资讯" }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "圈内广宣" }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "fd-member-equity-line-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToRegister(1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }),
                    _hoisted_22
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "fd-member-equity-box",
              span: 8,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_image, {
                      class: "fd-member-equity-icon-img",
                      src: require('@/assets/fd/member/u726.png')
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_form, {
                      class: "fd-member-equity-line-form",
                      "label-width": "70px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "软件账号" }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "项目查询" }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "管理统计" }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "专才招募" }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "行业交流" }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "行业资讯" }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "圈内广宣" }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "fd-member-equity-line-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToRegister(2)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    }),
                    _hoisted_36
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              class: "fd-member-equity-box",
              span: 8,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_el_image, {
                      class: "fd-member-equity-icon-img",
                      src: require('@/assets/fd/member/u749.png')
                    }, null, 8, ["src"])
                  ]),
                  _hoisted_39,
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_el_form, {
                      class: "fd-member-equity-line-form",
                      "label-width": "70px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "软件账号" }, {
                          default: _withCtx(() => [
                            _hoisted_42
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "项目查询" }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "项目报名" }, {
                          default: _withCtx(() => [
                            _hoisted_44
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "签约进驻" }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "被检索邀约" }, {
                          default: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "拎包培训" }, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "行业交流" }, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "专才招募" }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "圈内广宣" }, {
                          default: _withCtx(() => [
                            _hoisted_50
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "fd-member-equity-line-btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToRegister(3)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_51
                      ]),
                      _: 1
                    }),
                    _hoisted_52
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "fd-member-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_53
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          class: "fd-member-flow",
          gutter: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 4,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "fd-member-flow-icon",
                  color: "#ccc"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Edit))
                  ]),
                  _: 1
                }),
                _hoisted_54
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "fd-member-flow-arrow" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Right))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "fd-member-flow-icon",
                  color: "#ccc"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Coin))
                  ]),
                  _: 1
                }),
                _hoisted_55
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "fd-member-flow-arrow" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Right))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "fd-member-flow-icon",
                  color: "#ccc"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(WalletFilled))
                  ]),
                  _: 1
                }),
                _hoisted_56
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 2,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "fd-member-flow-arrow" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Right))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              offset: 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  class: "fd-member-flow-icon",
                  color: "#ccc"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CoffeeCup))
                  ]),
                  _: 1
                }),
                _hoisted_57
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_58
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})